<template>
  <div class="orders-list-table">
    <el-table
      :data="dataList"
      ref="multipleTable"
      @selection-change="onSelectionChange"
    >
      <template
        v-for="{ type, prop, label, width, slot, align, fixed } in config"
      >
        <el-table-column
          :key="prop"
          :label="label"
          :type="type"
          :min-width="width"
          :align="align"
          v-if="type"
        ></el-table-column>
        <el-table-column
          :key="prop"
          :prop="prop"
          :label="label"
          :min-width="width"
          :fixed="fixed"
          :align="align"
          v-else-if="slot"
        >
          <template slot-scope="scope">
            <template v-if="slot === 'afterNo'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="itemN" :style="{ zIndex: 100 - scope.$index }">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 98%;
                  "
                >
                  <div style="display: flex">
                    <div style="margin-left: 40px">
                      订单编号：{{ scope.row.orderInfo.orderNo || "--" }}
                    </div>
                    <div style="margin-left: 40px">
                      下单时间：{{ scope.row.orderInfo.payTime || "--" }}
                    </div>
                    <div style="margin-left: 40px">
                      提交时间：{{ scope.row.createdTime || "--" }}
                    </div>
                    <div style="margin-left: 40px">
                      审核时间：{{ scope.row.approveTime || "--" }}
                    </div>
                  </div>
                  <div>
                    <el-dropdown
                      placement="bottom"
                      @command="handleCommand($event, scope.row)"
                    >
                      <span class="el-dropdown-link" style="color: #4168e7">
                        更多<i
                          class="el-icon-arrow-down el-icon--right"
                          style="color: #4168e7"
                        ></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">查看</el-dropdown-item>
                        <el-dropdown-item
                          command="2"
                          v-if="
                            scope.row.status == 1 && scope.row.afterType != 0
                          "
                          >审核</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="3"
                          v-if="scope.row.status == 5"
                          >换货寄出</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="4"
                          v-if="scope.row.status == 6"
                          >修改换货单号</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="5"
                          v-if="scope.row.status == 3"
                          >退货单号</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="6"
                          v-if="scope.row.status == 4"
                          >修改退货单号</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="7"
                          v-if="scope.row.status == 4"
                          >查看退货物流</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="8"
                          v-if="scope.row.status == 6"
                          >查看换货物流</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="9"
                          v-if="scope.row.status == 6"
                          >确认收货</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="10"
                          v-if="scope.row.status == 4"
                          >确认收货</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              {{ scope.row.afterNo }}
            </template>
            <template v-if="slot === 'info'">
              <div
                class="mesSty"
                v-for="(item, index) in scope.row.orderAfterDetailList"
                :key="index"
              >
                <!-- <img class="imgSty" src="https://dummyimage.com/72x54/FF6600" alt="">-->
                <el-image :src="item.goodsImg" fit="cover"></el-image>
                <div class="mesFont">
                  <p :title="item.goodsName + '*' + item.afterQuantity">
                    <span>{{ item.goodsName }}</span>
                  </p>
                  <p>
                    {{ item.goodsSkuName }}&nbsp;数量: {{ item.afterQuantity }}
                  </p>
                </div>
              </div>
            </template>
            <template v-if="slot === 'userName'">
              <p>{{ scope.row.orderInfo.userName }}</p>
              <p>ID:{{ scope.row.orderInfo.userId }}</p>
              <p>{{ scope.row.orderInfo.userPhone }}</p>
            </template>
            <template v-if="slot === 'postName'">
              <p>{{ scope.row.orderInfo.postName }}</p>
              <p>{{ scope.row.orderInfo.postPhone }}</p>
            </template>
            <template v-if="slot === 'address'">
              <p>
                {{ scope.row.orderInfo.postDistrictAddress
                }}{{ scope.row.orderInfo.postAddress }}
              </p>
            </template>
            <template v-if="slot === 'orderTypeLabel'">
              <p>{{ scope.row.orderInfo.orderTypeLabel }}</p>
            </template>
            <template v-if="slot === 'status'">
              <p :title="scope.row.statusLabel">
                <i
                  v-bind:class="[
                    { 'danger-bg': scope.row.status == 99 },
                    { 'warning-bg': scope.row.status < 4 },
                    'round',
                    { 'success-bg': scope.row.status === 6 },
                  ]"
                ></i>
                {{ scope.row.statusLabel }}
              </p>
              
            </template>
            <template v-if="slot === 'price'">
              <template>
                <p v-if="scope.row.afterType != 2">
                  ￥{{ scope.row.refundMoney }}
                </p>
                <p v-else>--</p>
              </template>
            </template>
            <!-- <template v-if="slot === 'operation'">
              <div style="display: flex; flex-wrap: wrap">
                <p
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="platformAfterOrderDetail(scope.row)"
                >
                  查看
                </p>
                <p
                  v-if="scope.row.status == 1 && scope.row.afterType != 0"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="applyDialog(scope.row)"
                >
                  审核
                </p>
                <p
                  v-if="scope.row.status == 5"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="outGoods(scope.row, 'delivery')"
                >
                  换货寄出
                </p>
                <p
                  v-if="scope.row.status == 6"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="outGoods(scope.row, 'hedit')"
                >
                  修改换货单号
                </p>
                <p
                  v-if="scope.row.status == 3"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="outGoods(scope.row, 'fedit')"
                >
                  退货单号
                </p>
                <p
                  v-if="scope.row.status == 4"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="outGoods(scope.row, 'tedit')"
                >
                  修改退货单号
                </p>
                <p
                  v-if="scope.row.status == 4"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="lookInfo(scope.row, 1)"
                >
                  查看退货物流
                </p>
                <p
                  v-if="scope.row.status == 6"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="lookInfo(scope.row, 2)"
                >
                  查看换货物流
                </p>
                <p
                  v-if="scope.row.status == 6"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="stock(scope.row, 'user')"
                >
                  确认收货
                </p>
                <p
                  v-if="scope.row.status == 4"
                  style="margin-right: 20px; cursor: pointer; color: #409eff"
                  @click="stock(scope.row, 'five')"
                >
                  确认收货
                </p>
              </div>
            </template> -->
          </template>
        </el-table-column>
        <el-table-column
          :key="prop"
          :prop="prop"
          :label="label"
          :min-width="width"
          :align="align"
          v-else
        ></el-table-column>
      </template>
    </el-table>
    <el-dialog
      title="温馨提示"
      :visible.sync="isInfo"
      width="518px"
      :append-to-body="true"
    >
      <template>
        <div style="font-size: 20px">是否确认收货?</div>
        <div v-if="this.typeI == 'user'">
          请确认平台用户是否收货，该操作不可修改！
        </div>
        <div v-else>请确认仓库收货，该操作不可修改！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isInfo = false">取消</div>
          <div class="info-s" @click="submitInfo">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrdersListTable',
  props: {
    afterSale: {
      type: String,
      default: () => ''
    },
    typeStr: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ' '
    },
    heightStr: {
      type: String,
      default: () => '500px'
    },
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Array,
      default: () => []
    },
    dataList: { // 数据列表
      type: Array,
      default: () => []
    },
    parArrayArr: { // 按钮权限
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isInfo: false,
      radio: 3,
      isApply: false,
      userInfo: {},
      operationActiveIndex: '1',
      popSty: false,
      isShowCom: {}, // 操作 按钮 组件显示 默认 全为 false
      isShowTime: {
        closedTime: false, // 关闭时间
        createdTime: false, // 下单时间
        finishedTime: false, // 审核时间
        submitDate: false // 提交审核时间
      },
      routeObj: {},
      typeI: '',
      orderId: ''
    }
  },
  watch: {
    config: {
      handler (newVal, oldVal) {
        console.log(newVal)
      },
      deep: true
    },
    dataList: {
      handler (newVal, oldVal) {
        // console.log(newVal)
        // setTimeout(_ => {
        //   this.resetStyle() // 样式调整
        // }, 100)
      },
      deep: true
    },
    typeStr (value) {
      // console.log(value)
      this.showCom() // 操作 按钮 组件显示
    },
    // afterSale: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal)
    //   }
    // },
    $route () {
      // this.testFun();
    }
  },
  mounted () {
    // console.log(this.dictionaries.after_sale_reason)
    this.$nextTick(_ => {
      // this.resetDate()
      console.log('afterSale==', this.afterSale)
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.onShowTime()
    })
  },
  created () {
    this.routeObj = this.$route
  },
  methods: {
    handleCommand (e, item) {
      console.log(e, item)
      if (e == 1) {
        this.platformAfterOrderDetail(item)
      } else if (e == 2) {
        this.applyDialog(item)
      } else if (e == 3) {
        this.outGoods(item, 'delivery')
      } else if (e == 4) {
        this.outGoods(item, 'hedit')
      } else if (e == 5) {
        this.outGoods(item, 'fedit')
      } else if (e == 6) {
        this.outGoods(item, 'tedit')
      } else if (e == 7) {
        this.lookInfo(item, 1)
      } else if (e == 8) {
        this.lookInfo(item, 2)
      } else if (e == 9) {
        this.stock(item, 'user')
      } else if (e == 10) {
        this.stock(item, 'five')
      }
    },
    submitInfo () {
      if (this.typeI == 'user') {
        let data = {
          id: this.orderId
        }
        this.$api.confirmUser(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '收货成功'
            })
            this.isInfo = false
            this.$parent.fetchData()
          }
        })
      } else {
        let data = {
          id: this.orderId
        }
        this.$api.confirmFive(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '收货成功'
            })
            this.isInfo = false
            this.$parent.fetchData()
          }
        })
      }
    },
    stock (row, type) {
      this.isInfo = true
      this.typeI = type
      this.orderId = row.id
    },
    outGoods (row, type) {
      let data = {
        val: row,
        type: type
      }
      this.$emit('optionDialog', data)
    },
    lookInfo (row, type) {
      let data = {
        val: row,
        type: type
      }
      this.$emit('lookDialog', data)
    },
    applyDialog (row) {
      this.$emit('applyDialog', row)
    },
    platformAfterOrderDetail (row) {
      console.log(row)
      this.$router.push({
        name: 'platformAfterOrderDetail',
        query: {
          id: row.id,
          afterType: row.afterType
        }
      })
    },
    apply () {
      this.isApply = true
    },
    onShowTime () {
      const routeName = this.$route.name
      switch (routeName) {
        case 'ordersList': // 客服订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'examinationOrderList': // 审核订单
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleOrdeList': // 售后订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleRecordList': // 售后记录
          break
        default:
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.finishedTime = true // 审核时间
        // console.log('%c默认值！👀', 'color:#fff;font-size:1.2rem;padding:0.8rem 1.6rem;border-radius: 5px;background-color: #3eaf7c;font-family: "Microsoft YaHei",Arial,sans-serif;')
      }
      console.log(routeName, this.isShowTime)
    },
    resetStyle () {
      this.$nextTick(_ => {
        // 获取 所有行
        const elTableRowFirst = document.getElementsByClassName('el-table__row')
        // elTableRowFirst.forEach((item, index) => {
        //   if (index === 0) {
        //     // 获取  第一行的第二个
        //     // return console.log(item)
        //     const elTableCell = item.getElementsByClassName('el-table__cell')[1]
        //     const elTableCell5 = item.getElementsByClassName('el-table__cell')[5]
        //     const elTableCelldivCell = elTableCell5.getElementsByClassName('cell')[0]

        //     const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
        //     if (!relationOrder) {
        //       elTableCell.style.paddingTop = '45px'
        //       elTableCelldivCell.setAttribute('style', '')
        //       // console.log('没找到关联订单调整 ppadding-top')
        //     } else {
        //       elTableCell.setAttribute('style', '')
        //       elTableCelldivCell.style.marginTop = '30px'
        //     }
        //   } else {
        //     // 获取  其它行的第二个
        //     // return console.log(item)
        //     const elTableCell = item.getElementsByClassName('el-table__cell')[1]
        //     const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
        //     const mesSty = elTableCell.getElementsByClassName('mesSty')[0]
        //     if (relationOrder) {

        //     } else {
        //       mesSty.setAttribute('style', '')
        //     }
        //   }
        // })
      })
    },
    // 页面跳转
    toOtherPages (name, parameter, type) {
      // console.log(name, parameter, type)
      // console.log(parameter)
      // return
      let query = {}
      query = { orderNo: parameter.orderNo, orderId: parameter.orderId, id: parameter.orderId }
      this.$router.push({ name, query })
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },


    onSelectionChange (val) { // 多选
      // this.multipleSelection = val;
      // console.log(val)
      this.$emit('tableSelectionChange', val)
    }
  }
}
</script>
<!--<style scoped>-->
<style lang="scss" scoped>
.pass {
  width: 414px;
  height: 36px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 2px;
  line-height: 36px;
  padding-left: 12px;
  margin-top: 24px;
  margin-bottom: 100px;
  .price {
    color: #f63c56;
  }
}
::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}
::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}
.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}
.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}
.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}
.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: rgb(64, 158, 255);
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.tooltip {
  position: relative;
  /*margin: 50px auto;*/
  /*border: 1px solid;*/
  cursor: pointer;
}

.tooltip[aria-label]:hover:after {
  content: attr(aria-label);
  position: absolute;
  bottom: -38px;
  left: 30%;
  /*border: 1px solid;*/
  width: 80px;
  text-align: center;
  border-radius: 3px;
  padding: 5px;
  color: #ffffff;
  font-size: 12px !important;
  background-color: rgba(0, 0, 0, 0.5);
}

.mesSty:after {
  clear: both;
  display: table;
  content: "";
}

/*圆点*/
.round {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background-color: #0b7df3;
  display: inline-block;
}

.primary-bg {
  background-color: #409eff !important;
}
.success-bg {
  background-color: #12ab62 !important;
}
.warning-bg {
  background-color: #e6a23c !important;
}
.danger-bg {
  background-color: #f56c6c !important;
}
.info-bg {
  background-color: #909399 !important;
}

.el-table {
  overflow: unset;
}

::v-deep.el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: #ffffff;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f8f8f8;
}

::v-deep.el-table th.el-table__cell .cell {
  color: #333333;
  font-size: 14px;
}

/deep/ .el-table tr {
  position: relative;
  width: 100%;
}
/deep/ .el-table .el-table__body-wrapper {
  /*padding-top: 40px;*/
  overflow: unset;
}
::v-deep.el-table .el-table__body .el-table__row {
  position: relative !important;
}
::v-deep.el-table .el-table__body .el-table__row:first-child {
  /*background-color: #2D7EDF;*/
}
::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
  position: absolute;
  top: 8px;
  left: 0;
  z-index: 10000;
}
::v-deep.el-table
  .el-table__body
  .el-table__row:first-child
  td:first-child
  .cell {
  top: 8px;
}
::v-deep.orders-list-table
  .el-table
  .el-table__body
  .el-table__row
  .el-table__cell:nth-child(2) {
  position: static !important;
  /*padding: 5px 0;*/
}
::v-deep.orders-list-table
  .el-table
  .el-table__body
  .el-table__row
  .el-table__cell:nth-child(1) {
  /*position:relative!important;*/
}
::v-deep.orders-list-table
  .el-table
  .el-table__body
  .el-table__row
  .el-table__cell {
  // background-color: #0b7df3;
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}
::v-deep.orders-list-table
  .el-table
  .el-table__body
  .el-table__row:first-child
  .el-table__cell:nth-child(2) {
  /*background-color: #0b7df3;*/
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}
::v-deep.orders-list-table
  .el-table
  .el-table__body
  .el-table__row
  .el-table__cell:nth-child(2) {
  /*background-color: #0b7df3;*/
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}
::v-deep.orders-list-table
  .el-table
  .el-table__row:first-child
  .el-table__cell:nth-child(2)
  .item {
  /*background-color: #0b7df3;*/
  margin-top: 0;
}
::v-deep.orders-list-table .el-table .el-table__cell:nth-child(2) .item {
  /*background-color: #0b7df3;*/
  margin-top: -44px;
}
.item {
  width: 100%;
  height: 40px;
  background-color: #ebeef5;
  padding: 7px 0 7px 50px;
  position: absolute;
  /*top: 0;*/
  left: 0;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}
.itemN {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  background-color: #ebeef5;
  // padding: 7px 0 7px 50px;
  position: absolute;
  top: 0;
  left: 0;
  margin-bottom: 20px;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}
::v-deep.el-table
  .el-table__body
  .el-table__row:first-child
  td:nth-child(2)
  .item {
  top: 0;
  /*background-color: rgba(0,0,0,0.3);*/
}
.item > div {
  float: left;
}

.item div:first-child label:first-child {
  font-size: 14px;
  color: #4168e7;
  line-height: 10px;
  display: block;
}

.item div:first-child label:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}

.hint_pr {
  padding-left: 8vh;
  // line-height: 20px;
}

.hint_pr-operation {
  margin-right: 20px;
  float: right !important;
  position: relative;
  z-index: 10;
}

.hint_pr-operation label {
  cursor: pointer;
}

.hint_pr-operation ul {
  display: none;
  position: absolute;
  right: -14px;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1000;
  cursor: pointer;
}

.hint_pr-operation:hover ul {
  display: block;
  border-radius: 3px;
}

.hint_pr-operation ul li {
  text-align: center;
  line-height: 30px;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
}

.hint_pr-operation ul li:last-child {
  border-bottom: none;
}

.imgSty {
  width: 80px;
  display: block;
}

.mesSty {
  /*display: flex;*/
  /*align-items: center;*/
  margin-bottom: 8px;
}

.mesSty .el-image {
  width: 64px;
  height: 64px;
  float: left;
}

.mesSty .mesFont {
  float: left;
  width: calc(100% - 100px);
  //text-align: center;
}

.mesSty .mesFont p {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-left: 5px;
  color: #333333;
  /*font-size: 12px;*/
  line-height: 27px;
}

.mesSty .mesFont p:nth-child(2) {
  color: #999999;
  font-size: 12px;
}

.mesSty .mesFont p:nth-child(2) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.iconSty {
  float: right;
  cursor: pointer;
}

@media (min-width: 1500px) {
}
@media screen and (max-width: 1500px) {
  .item div:first-child label:first-child {
    font-size: 14px;
    color: #4168e7;
    line-height: 20px;
    display: block;
  }
  .item {
    width: 100%;
    height: 40px;
    background-color: #ebeef5;
    padding: 0px 0 7px 50px;
    position: absolute;
    /*top: 0;*/
    left: 0;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
  .hint_pr {
    padding-left: 8vh;
    line-height: 20px;
  }
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -32px;*/
  }
}
@media screen and (max-width: 1200px) {
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -25px;*/
  }
}
@media (min-width: 768px) {
}
.afterSaleAmount {
  margin-top: 40px;
}
.afterSaleStatus {
  margin-top: 50px;
}
</style>
